import { Empty } from 'antd';
import { EmptyProps } from 'antd/lib';

interface IProps extends EmptyProps {
	style?: React.CSSProperties;
	className?: string;
}

const GEmpty = ({ style, className, ...emptyProps }: IProps) => {
	const defaultStyle: React.CSSProperties = {
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column'
	};

	return (
		<Empty
			style={{ ...style, ...defaultStyle }}
			className={`wms-empty ${className}`}
      {...emptyProps}
		/>
	);
};

export default GEmpty;
